<template>
  <div>
    <v-progress-linear v-if="cargando" indeterminate color="purple" class="mb-2" />

    <ag-grid-vue
      :gridOptions="gridOptions"
      class="ag-theme-balham ag-grid-table-presupuesto"
      :columnDefs="columnDefs"
      :defaultColDef="defaultColDef"
      @grid-ready="onGridReady"
      :rowData="items"
      rowSelection="single"
      colResizeDefault="shift"
      :animateRows="false"
      :floatingFilter="true"
      :pagination="false"
      :rowClassRules="rowClassRules"
      @selection-changed="onSelectionChanged"
      @first-data-rendered="onFirstDataRendered"
      :alwaysShowVerticalScroll="true"
      :suppressPaginationPanel="true">
    </ag-grid-vue>
  </div>
</template>
  
<script>
import listadoAgGridMixin from '../mixins/listado-ag-grid-mixin';
import { cellRendererActivoInactivo, cellRendererNumeroRegistro } from '../utils';

export default {
  name: 'ListadoCuentaPagadora',
  mixins: [listadoAgGridMixin],
  data() {
    return {
      columnDefs: [
        {
          headerName: 'NRO. REG.',
          cellRenderer: cellRendererNumeroRegistro,
          filter: false,
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: false,
          minWidth: 150,
          maxWidth: 150,
        },
        {
          headerName: 'SEDE',
          field: 'sede',
          filter: false,
          minWidth: 250,
          maxWidth: 250,
        },
        {
          headerName: 'BANCO',
          field: 'nombre',
          filter: false,
          minWidth: 250,
          maxWidth: 250,
        },
        {
          headerName: 'TIPO DE CUENTA',
          field: 'descripcion',
          filter: false,
          minWidth: 400,
        },
        {
          headerName: 'NRO DE CUENTA',
          field: 'nro',
          filter: false,
          minWidth: 250,
          maxWidth: 250,
        },
        {
          headerName: 'ESTADO',
          filter: false,
          cellRenderer: cellRendererActivoInactivo,
          minWidth: 100,
          maxWidth: 100,
        },
      ],
    };
  },
};
</script>

<style>
@import '~ag-grid-community/dist/styles/ag-grid.css';
@import '~ag-grid-community/dist/styles/ag-theme-balham.css';

.ag-grid-table-presupuesto {
  height: calc(var(--vh, 1vh) * 100 - 16rem);
}
</style>
  